import * as Yup from "yup";
import LockIcon from "@material-ui/icons/Lock";
import Typography from "@material-ui/core/Typography";
import React, { ChangeEvent, useState } from "react";
import { Auth } from "aws-amplify";
import { Field, Form, Formik, FormikHelpers } from "formik";
import { useHistory } from "react-router-dom";

import AppLink from "../../../../components/elements/AppLink";
import BaseInput from "../../../../components/elements/BaseInput";
import Button from "../../../../components/elements/Button";
import FormError from "../../../../components/elements/FormError";
import FormFieldError from "../../../../components/elements/FormFieldError";
import classes from "./ResetPasswordForm.module.scss";
import { successToaster } from "../../../../helpers/toasters";

type FormInitialValues = {
  userName: string;
};

const ResetPasswordForm = () => {
  const formInitialValues: FormInitialValues = {
    userName: "",
  };

  const validationSchema = Yup.object({
    userName: Yup.string().required("Required field."),
  });

  const history = useHistory();

  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleSubmit = async (values: FormInitialValues, actions: FormikHelpers<FormInitialValues>) => {
    try {
      const { userName } = values;
      setIsLoading(true);
      await Auth.forgotPassword(userName);
      setIsLoading(false);
      actions.resetForm();
      successToaster("Confirmation code was successfully sent to your email!");
      history.push({ search: new URLSearchParams({ userName }).toString() });
    } catch (error) {
      const err = error as any;
      setIsLoading(false);
      actions.resetForm();
      setErrorMessage(`There was an error: ${err.message}`);
    }
  };

  const handleFieldChange =
    (formikHandler: (e: string | ChangeEvent<any>) => void) => (e: string | ChangeEvent<any>) => {
      formikHandler(e);
      if (errorMessage) {
        setErrorMessage("");
      }
    };

  return (
    <Formik
      initialValues={formInitialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
      validateOnBlur={false}
    >
      {({ handleChange, values }) => (
        <Form className={classes.container}>
          <div className={classes.formContent}>
            <div className={classes.formHeader}>
              <Typography variant="h3">Forgot Password</Typography>
              <LockIcon className={classes.icon} />
            </div>

            <Typography className={classes.infoText}>
              Please enter your username, confirmation code to reset password will be sent to your email
            </Typography>

            <div className={classes.inputs}>
              <div className={classes.input}>
                <Field
                  as={BaseInput}
                  value={values.userName}
                  error={!!errorMessage}
                  name="userName"
                  variant="outlined"
                  label="Username *"
                  onChange={handleFieldChange(handleChange("userName"))}
                />

                <FormFieldError name="userName" />
                <FormError className={classes.formError} errorMessage={errorMessage} />
              </div>
            </div>

            <div className={classes.formControls}>
              <Button variant="contained" type="submit" isLoading={isLoading} fullWidth>
                Send
              </Button>

              <AppLink highlighted to="/">
                Cancel
              </AppLink>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default ResetPasswordForm;
